import { FormulaResult, PumpSizingFormData } from "../../../types/types";

export function calculateSewageGpm(formData: PumpSizingFormData): FormulaResult {
	const { totalFixtureUnits } = formData.gpmData.sewage;
	if (totalFixtureUnits <= 0) {
		return null;
	}

	return 4.5 * totalFixtureUnits ** 0.45;
}
